import { makeRestApiRequest, RestApiRequestConfig } from '~src/httpClient/RestApiService';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { createBaseRestConfig } from '../GroupSetsServerApiHelper';

export interface IDeleteGroupSetRequestBody {
    groupSet: {
        name: string;
    };
}

export interface IDeleteGroupSetResult extends IResult {
}

export async function deleteGroupSet(groupSetId: string): Promise<IDeleteGroupSetResult> {
    const config: RestApiRequestConfig<{}, {}> = {
        ...createBaseRestConfig(),
        httpMethod: 'DELETE',
        endpoint: `groupsets/` + groupSetId,
    };

    let response = makeRestApiRequest<{}, any, {}>(config);
    return response.then((result: any) => {
        return result;
    }, (error) => Promise.reject(error));
}